export default __webpack_public_path__ + "static/img4-5e6371656857c3b4273dc8f67e4b04e2.png";